import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class IntramirrorGenderMapApiClient extends AdvancedApiClient {

    static entityType = "IntramirrorGenderMap"

    constructor(token, genderId, id) {
        super();

        this.setEntityType(IntramirrorGenderMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/gender/{gid}/intramirror-map/{id}")
                .setRouteParam("gid", genderId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/gender/{gid}/intramirror-map")
                .setRouteParam("gid", genderId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}